import Home from './components/Home.vue';
import Panorama from './components/Panorama.vue';
import Imprint from './components/Imprint.vue';
import Privacy from './components/Privacy.vue';
import Error from './components/Error.vue';

export default [
  {
    path: '/',
    component: Home,
    name: "home",
    meta: {
      title: "Schabbell 360",
      // metaTags: [
      //   {
      //     name: "description",
      //     content: "Schabbell 360 - Home Screen"
      //   },
      //   {
      //     name: "og:description",
      //     content: "Schabbell 360 - Home Screen"
      //   }
      // ]
    }
  },
  {
    path: '/scene/:id',
    component: Panorama,
    name: "panorama",
    meta: {
      // title: "Schabbell 360",
      // metaTags: [
      //   {
      //     name: "description",
      //     content: "Schabbell 360 - Home Screen"
      //   },
      //   {
      //     name: "og:description",
      //     content: "Schabbell 360 - Home Screen"
      //   }
      // ]
    }
  },
  {
    path: '/error',
    component: Error,
    name: "error",
    meta: {
      title: "Schabbell 360 – Fehler",
      // metaTags: [
      //   {
      //     name: "description",
      //     content: "Schabbell 360 - Home Screen"
      //   },
      //   {
      //     name: "og:description",
      //     content: "Schabbell 360 - Home Screen"
      //   }
      // ]
    }
  },
  {
    path: '/impressum',
    component: Imprint,
    name: "imprint"
  },
  {
    path: '/datenschutz',
    component: Privacy,
    name: "privacy"
  },
  {
    path: '*',
    component: Error,
    name: "error 404"
  }
]
